<template>
  <div>
    
    <app-header />
    <!-- <wrap class="index"> -->
      <!-- 之前首页内容以下 -->
   <!--    <div style="display:none;">
        <section class="section-1" id="" style="overflow: hidden;">
          <div class="content-1 zedit">
            <h3>AI健康认知大脑</h3>
            <p>用AI认知计算技术，配合人类进行健康和医疗诊断、分析工作<br />解决人脑不擅长解决的一些问题</p>
          </div>
          <div class="bbgg-box">
            <div class="bg0 pa">
              <div class="bg1"></div>
            </div>
            <div class="hx-box pa">
              <ul class="pr">
                <li class="hx-k2 pa0">
                  <span></span>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <section class="section-1-2">
          <div class="content-1-2">
            <h3 class="h3-1">吾征AI认知矩阵计算和动态平衡系统实验室</h3>
            <div class="div-1 overflow">
              <div class="left">
                <div class="img-d vertical center">
                  <img src="../assets/img/model-1.png" />
                </div>
                <p>一种全新的大健康计算系统<br /> 以中文大数据矩阵动态平衡为核心</p>
              </div>
              <div class="left">
                <div class="img-d vertical center">
                  <img src="../assets/img/model-2.png" />
                </div>
                <p>理解自然语言<br />并以此为基础和患者更自然的交互</p>
              </div>
              <div class="left">
                <div class="img-d vertical center">
                  <img src="../assets/img/model-3.png" />
                </div>
                <p>从结构化和非结构化海量数据中<br />学习和积累所需知识</p>
              </div>
              <div class="left">
                <div class="img-d vertical center">
                  <img src="../assets/img/model-4.png" />
                </div>
                <p>从医疗健康领域的顶尖人才获取<br />并共享专业知识</p>
              </div>
              <div class="left">
                <div class="img-d vertical center">
                  <img src="../assets/img/model-5.png" />
                </div>
                <p>改善认知方式<br />探索全新的医疗健康模式</p>
              </div>
              <div class="left">
                <div class="img-d vertical center">
                  <img src="../assets/img/model-6.png" />
                </div>
                <p>提升健康认知的决策精准性<br />和前瞻性</p>
              </div>
            </div>
          </div>
        </section>
        <section class="section-1-1">
          <div class="content-1-2">
            <h3 class="h3-2">吾征AI运用认知矩阵计算技术 让机器像医生一样思考</h3>
            <div class="div-2 overflow">
              <div class="left dark">
                <h4>计算</h4>
                <p>提供性能强劲的并行计算和分布式计算能力<br />同时与移动互联网、物联网融合<br />实现云端智能认知诊断</p>
                <div class="img-d">
                  <img src="../assets/img/decision-1.jpg" />
                </div>
              </div>
              <div class="left light">
                <h4>领会</h4>
                <p>通过自然语言处理技术和NLP技术<br />分析推导患者自诉以及机器监测数据里面的结构化和非结构化数据<br />包括文本、图片、音频、视频等</p>
                <div class="img-d">
                  <img src="../assets/img/decision-2.jpg" />
                </div>
              </div>
              <div class="left dark">
                <h4>推导</h4>
                <p>将知识碎片进行拼接、推导、分析<br /> 获取深层次的健康和疾病认知<br />诊断和预测决策依据<br /></p>
                <div class="img-d">
                  <img src="../assets/img/decision-3.jpg" />
                </div>
              </div>
              <div class="left light">
                <h4>学习</h4>
                <p>通过机器学习技术<br />优化模型和不断成长<br />像人类一样学习疾病知识<br />开启疾病智能认知诊断新时代</p>
                <div class="img-d">
                  <img src="../assets/img/decision-4.jpg" />
                </div>
              </div>
              <div class="left dark">
                <h4>互动</h4>
                <p>以更自然的方式与人进行高效互动<br />快速理解患者自诉流程中<br />隐藏的关键意思、暗知识以及关键信息等</p>
                <div class="img-d">
                  <img src="../assets/img/decision-5.jpg" />
                </div>
              </div>
              <div class="left light">
                <h4>可视</h4>
                <p>丰富的可视化呈现模式<br />最直观的方式获取认知诊断结果<br />提供疾病预测和预警解决方案</p>
                <div class="img-d">
                  <img src="../assets/img/decision-6.jpg" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="section-2">
          <h4>开启从大数据到知识库中的知识要素映射之旅</h4>
          <div class="section-2-gif">
            <i></i>
            <i></i>
            <i></i>
            <i></i>
          </div>
        </section>
        <section class="section-3">
          <h4>吾征AI的核心优势：类脑知识认知和建模</h4>
          <div class="content-3 overflow">
            <div class="left text-1">
              <h5>中文语义智能认知诊断引擎</h5>
              <p>基于中文语义智能认知诊断引擎，无论是医院、养老、社区等的医疗健康管理机构内部数据，还是互联网外部数据，每种类型的数据都可能成为高效决策的关键，让数据为您所用。通过使用机器学习，分析每个数据维度并自动提供最佳认知结果，实现了真正的认知计算。</p>
            </div>
            <div class="right img-1"></div>
            <hr />
            <div class="left img-2"></div>
            <div class="right  text-2">
              <h5>认知分析一键连接所有数据</h5>
              <p>建立包含认知和人工智能在内的健康大数据分析系统是健康医疗IT化和健康医疗单位的首要任务，特别是认知技术，它将是未来理解个人健康状况，提供医疗建议，让患者加入自主健康管理的关键所在。通过我们提供的丰富的文本源接入方式和认知分析系统，能有效的将数据汇集，并智能分析和认知。</p>
            </div>
            <hr />
            <div class="left text-3">
              <h5>以用户为中心的可视化分析</h5>
              <p>基于对医疗健康及企业以及机构、个人的业务积累，并以此对数据进行基本评估，提供丰富的认知应用模型库，进行任意维度的多维分析，您也可以完全自定义仪表盘、数据报告，用最适合您的方式去洞察数据背后的价值。</p>
            </div>
            <div class="right img-3"></div>
          </div>
        </section>
        <section class="section-4">
          <h3>解决方案</h3>
          <h4>吾征AI认知矩阵计算技术，开启疾病与健康智能认知诊断新时代</h4>
          <div class="content-4">
            <div>
              <div class="swiper-container">
                <div class="swiper-wrapper">
                  <div class="swiper-slide"><img src="../assets/img/z_school_p.png" />
                    <p><img src="../assets/img/z_school.png" /></p>
                  </div>
                  <div class="swiper-slide"><img src="../assets/img/z_family_p.png" />
                    <p><img src="../assets/img/z_family.png" /></p>
                  </div>
                  <div class="swiper-slide"><img src="../assets/img/z_office_p.png" />
                    <p><img src="../assets/img/z_office.png" /></p>
                  </div>
                  <div class="swiper-slide"><img src="../assets/img/z_community_p.png" />
                    <p><img src="../assets/img/z_community.png" /></p>
                  </div>
                  <div class="swiper-slide"><img src="../assets/img/z_life_p.png" />
                    <p><img src="../assets/img/z_life.png" /></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div> -->
      <!-- 之前首页内容以上 -->
      <!-- 新首页内容Start -->
      <div class="be_banner">
        <h2 class="be_banh2 pictxt"></h2>
        <div class="be_banBtn"><a href="/about">了解我们+</a></div>
        <div class="be_botBtn" style="display: none;">
          <a href="http://www.dataqu.cn?t=1">数趣</a>
          <a href="http://mcloud.dhbigdata.cn">中央厨房</a>
          <a href="http://www.moxiai.com/">魔系</a>
          <a href="http://dataqd.infobigdata.com/">腔调</a>
          <a href="http://www.wobian88.com/">彼岸</a>
          <a href="http://www.qthmedia.com/">钱塘号</a>
          <a href="http://www.jiupaicn.com/">九派号</a>
          <a href="http://www.jiaminsu.com">民宿加</a>
        </div>
      </div>

      <div class="index_about">
        <div class="index_about_two target">
          <dl>
            <dd>
              <!--  dd onclick="javascript:location.href='/coreTech'" -->
              <h1>
                <img src="../assets/images/index_about_two_ino1.png">
              </h1>
              <h2>核心技术</h2>
              <h3>人体医学生物特征认知计算的多模态选择及多层次融合技术</h3>
              <!-- <h4><a href="javascript:;">了解更多</a></h4> -->
            </dd>
            <dd>
              <h1>
                <img src="../assets/images/index_about_two_ino2.png">
              </h1>
              <h2>核心团队</h2>
              <h3>来自边缘计算、医学生物特征抽取和人工智能方面的专家和行业人士</h3>
              <!-- <h4><a href="javascript:;">了解更多</a></h4> -->
            </dd>
            <dd>
              <h1>
                <img src="../assets/images/index_about_two_ino3.png">
              </h1>
              <h2>发展历程</h2>
              <h3>2019年底吾征AI在北京正式成立，并获得了千万元的天使轮投资</h3>
              <!-- <h4><a href="javascript:;">了解更多</a></h4> -->
            </dd>
            <dd>
              <h1>
                <img src="../assets/images/index_about_two_ino4.png">
              </h1>
              <h2>了解吾征AI</h2>
              <h3>国内专注人体医学生物特征认知计算的技术公司，致力于利用生物特征多模态AI技术把人体“望闻问切”搬上互联网</h3>
              <!-- <h4><a href="javascript:;">了解更多</a></h4> -->
            </dd>
          </dl>
        </div>
        <div class="index_about_one meitd">
          <div class="meitdbox clear">
            <!--
            <div class="index-3 target index_cont_img">
              <img src="../assets/images/mvbg.jpg">
            </div> -->
            <div class="dx_w">
              <div class="dx_ws"></div>
              <div class="dx_wimg"><img src="../assets/img/dx_pic.png"></div>
              <div class="dx_wd"></div>
              <div class="dx_wl"><img src="../assets/img/dx_line.png"></div>
            </div>
            <div class=" i-a-o-right target action index_cont_txtlist">
              <span></span>
              <h3>国内专注人体医学生物特征认知识别系统•“AI+人体医学生物特征+IOT+智能应用”,并拥有成熟产品的认知计算公司。</h3>
              <span></span>
              <h4>宗旨：致力于改变传统的中医问诊模式，运用认知计算技术和大数据算法，为用户提供智能化“望、闻、问、切”以及个性化、精准的疾病和健康方面的解决方案。<br>使命：重新定义互联网时代的中西医结合“望闻问切”，通过人体医学生物特征认知计算技术+IOT +吾征侏罗纪芯片，开启大健康领域认知计算新时代。</h4>
              <h5>
                <a href="javascript:void(0);">
                  <img src="../assets/images/i-a-o-right1.jpg"></a>
                <a href="javascript:void(0);">
                  <img src="../assets/images/i-a-o-right2.jpg"></a>
                <a href="javascript:void(0);">
                  <img src="../assets/images/i-a-o-right3.jpg"></a>
              </h5>
            </div>
          </div>

        </div>
      </div>


    <!-- <div class="zhongjiantu6_3">
      <div class="continto">
        <div class="leftcont">
          <div class="title" style="font-size: 38px;padding-bottom: 30px;padding-top: 80px;">人体医学生物特征全息认知识别计算系统</div>
          <div class="title" style="padding-top: 0;font-size: 16px;color: #666666;  padding-bottom: 30px; line-height: 30px;">用AI认知计算技术，结合人体日常行为习惯、生活习惯、环境信息和体检信息进行综合疾病筛查与分析</div>
          <div class="btntitle6_3" @click="shaicha()">立即体验</div>
        </div>
        <img src="../assets/images/indexImg.png" alt="" class="imgin">
      </div>
    </div> -->

    <!-- <div class="zhongjiantu3_25">
      <div class="continto">
        <div class="titlein">慢性病风险评估与筛查</div>
        <div class="titleinps">慢性病风险筛查与评估，就是针对生活习惯、环境因素、智能设备、家庭遗传、体检结果指标等进行科学的分析，在未出现临床表现的人群中分析评估其健康危险因素，建立生活方式、环境、遗传等危险因素与健康状态之间的量化关系，预测个人在未来5~10年内多种慢性疾病的患病风险和概率，从而实现早预防，早干预的目标。</div>
        <div class="weiqunabox3_25">
          <div class="weiquna3_25" v-for="val in msg">
            <img :src="val.img" alt="" class="img">
            <div class="titlewei">{{val.name}}</div>
            <div class="titleweips">{{val.title}}</div>
            <div class="btnuni" @click="tiao(val.type,val.name)">立即体验</div>
          </div>
          <div class="weiquna3_25">
            <div class="img"></div>
            <div class="titlewei"></div>
            <div class="titleweips">更多风险评估系统即将上线</br>敬请期待</div>

          </div>
        </div>
        <div style="clear: both;"></div>
      </div>
    </div> -->

 <!--      <div class="bannera" style="position:relative;width:100%;overflow:hidden;">
        <div class="index_pro target imga">
          <a href="javascript:void(0);">
            <img src="../assets/images/jct.jpg">
            <dt><span>芥菜头</span>
              <font>饮食AI行为预警系统。</font>
            </dt>
          </a>
          <a href="javascript:void(0);">
            <img src="../assets/images/wyzm.jpg">
            <dt><span>吾医智盟</span>
              <font>在提供医药服务同时为健康管理师、营养师、老年养护师等提供资质考核服务平台，为资质需求客户提供从课程学习、培训，到证书考级等一体化的服务。</font>
            </dt>
          </a>
          <a href="javascript:void(0);">
            <img src="../assets/images/hjll.jpg">
            <dt><span>花简绿箩</span>
              <font>室内温湿度与病菌疾病风险智能预警系统。</font>
            </dt>
          </a>
          <a href="javascript:void(0);">
            <img src="../assets/images/ypzn.jpg">
            <dt><span>壹拍智能</span>
              <font>适合化验单场景的智能语义计算与图像识别系统。</font>
            </dt>
          </a>
        </div>

      </div> -->
      <!-- 行业应用 -->
      <section class="container cont4 zapply" style="margin-bottom: 0;">
        <div class="container">
          <p class="intro-tit textC">场景应用</p>
          <div class="flicker-example">
            <div class="flicker-box">
              <ul>
                <li>
                  <i class="apply-icon1"></i>
                  <h4>疾病病情文本相似度计算</h4>
                  <p>对各类病历等病情文本集进行预处理，提取出初始特征词，将其表示成由关键词和概念两部分组成的向量模型；然后分别计算关键词部分的语义相似度和概念部分的语义相似度，通过对两部分进行求和最终得到文本的语义相似度，辅助疾病推测与诊断；</p>
                </li>
                <li>
                  <i class="apply-icon2"></i>
                  <h4>疾病病理认知指标诊断</h4>
                  <p>系统利用各类终端设备采集患者的认知指标，而后将其传输到中央分析器，中央分析器使用根据认知指标构建的诊断模型进行疾病的诊断。利用该系统进行辅助诊断，可以实现90％的诊断准确度，适宜临床推广使用；</p>
                </li>
                <li>
                  <i class="apply-icon3"></i>
                  <h4>体相语义认知特征智能识别</h4>
                  <p>根据身体体相外显的生理特性，建立分层、动态、多分辨率的语义认知特征提取计算模型，实现体相特征或者征兆和语义认知特征的智能提取，可以使体相外显的信息描述更加符合人的主观认识；</p>
                </li>
                <li>
                  <i class="apply-icon4"></i>
                  <h4>智能危急值诊疗系统</h4>
                  <p>通过建立基于深度学习的图文危急值信息挖掘的危急值算法，发现可疑危急值，即刻通过互联网技术通知责任医师，医师确认后即刻通过移动互联网技术通知责任临床医师，实现疾病危急值的快速确认和传递，为治疗赢得时间。核心思想在于提供一种智能危急值诊疗系统，以解决现有的疾病危急值传递速度慢的问题；</p>
                </li>
                <li>
                  <i class="apply-icon5"></i>
                  <h4>智能问诊方法及系统</h4>
                  <p>系统通过语义模型计算患者提出问题中的语义信息，与疾病知识库中保存的问题及其语义信息比较，去除与用户提出的问题的语义不一致的问题，匹配到相似的问题，给出准确的诊断回答；</p>
                </li>
                <li>
                  <i class="apply-icon6"></i>
                  <h4>疾病早期智能筛查方法</h4>
                  <p>获取疾病m个训练样本分别在N个待选特征下的特征值，以及所述m个训练样本对应的分类标签；所述m、N分别为大于0的整数；确定所述N个待选特征中每个待选特征的重要性度量值；根据每个待选特征的重要性度量值，确定多个特征集合；针对每个特征集合：使用m个训练样本在该特征集合包含的每个待选特征下的特征值和所述m个待选特征对应的分类标签，训练分类模型，获得该特征集合对应的分类准确率；将分类准确率最高的特征集合包含的待选特征确定为选定特征。</p>
                </li>
                <li>
                  <i class="apply-icon7"></i>
                  <h4>临床症状特征权重推导疾病概率</h4>
                  <p>依据疾病的临床症状特征等信息，采取临床症状特征权重在不同疾病类型症状特征加权和建模的方式，基于临床症状特征关联关系数据及症状的使用频率数据，推导出一类或者某一个具体的疾病概率。</p>
                </li>
                <li>
                  <i class="apply-icon8"></i>
                  <h4>面向医学文献中作者的姓名消歧方法</h4>
                  <p style="text-indent: 0; padding-left: 300px;">
                    1) 从医学文献题录信息中抽取作者个人信息、构建作者之间的合著关系与引用关系等；<br />
                    2) 比对重名作者的邮箱；<br />
                    3) 计算重名作者所属机构与学科的相似度；<br />
                    4) 计算重名作者合著关系的相似度；<br />
                    5) 计算重名作者引用关系的相似度；<br />
                    6) 基于步骤3-5计算出的三类相似度聚类，即可对姓名消歧。
                  </p>
                </li>
                <!-- 新增 -->
                <li>
                  <i class="apply-icon9"></i>
                  <h4>基于人体粪便智能认知疾病系统</h4>
                  <p>基于ＴＦ-ＩＤＦ特征词定位算法识别出人体粪便性状的（包括粪便的颜色、气味、性状、软硬度以及粪便的内容物等）特征信息数据以及对应的疾病数据集合，利用余弦相似度算法分类器获取粪便特征信息认知学习模型，对待诊断粪便特征信息对应的粪便特征信息文本描述进行相似性筛查和诊断。</p>
                </li>
                <li>
                  <i class="apply-icon10"></i>
                  <h4>基于痰液性状认知的疾病征兆预测系统</h4>
                  <p>根据痰液性状的文本描述获取对应的健康数据以及疾病征兆数据，并建立数据调用库，通过该Boosting分类方法对痰液性状的文本描述进行训练，获取训练结果，根据该训练结果结合数据调用库建立诊断学习模型，获取待诊断用户痰液性状的文本描述，根据诊断学习模型对该待诊断用户痰液性状的文本描述进行判断，并根据判断结果进行诊断。</p>
                </li>
                <li>
                  <i class="apply-icon11"></i>
                  <h4>基于异常舌象的智能筛查方法及其系统</h4>
                  <p>建立中医舌诊的知识平台以及专家辅助诊断系统；在利用细粒度图像分类算法过程中，将空间位置特征引入对分类并进行建模，也就是对舌象的多个关键区域进行定位，根据舌象各个部位之间的空间关系进行建模，提高部位特征的完整性和判别性。</p>
                </li>
                <li>
                  <i class="apply-icon12"></i>
                  <h4>基于口臭伴随症状的疾病预测模型的构建方法及系统</h4>
                  <p>在确立口臭作为第一临床主诉症状的前提下，建立口臭伴随症状以及相应的疾病信息的第一疾病知识数据库；根据病理性和非病理性、聚类方法对所述第一疾病知识数据库进行分类，直至每个质心不再改变，得到第二疾病知识数据库；对所述第二疾病知识数据库提取特征向量，建立特征向量集合；计算症状特征与其对应的疾病之间的语义相似度，得到模型。</p>
                </li>
                <li>
                  <i class="apply-icon13"></i>
                  <h4>百日咳智能筛查方法及系统</h4>
                  <p>分别获取百日咳相关的流行病学史特征信息、临床征兆特征信息和病原学特征信息，建立相应的特征信息认知模型，根据特征信息系统认知模型中的数据信息，迭代计算百日咳特征信息的后验概率；将后验概率作为EM算法的输入，计算得到BKT认知模型的参数值，通过BKT认知模型推导出待测百日咳特征的认知结果。</p>
                </li>
                <li>
                  <i class="apply-icon14"></i>
                  <h4>基于涕液特征信息语义认知系统</h4>
                  <p>按照涕液颜色、涕液频次、产生时段、涕液形态和伴随症状作为涕液特征的顺序进行识别，将上述涕液特征作为行向量，特征的值作为列向量，构建涕液特征矩阵。结合语义识别单元输入的涕液特征矩阵，从标签集合单元选取标签集合，求取涕液特征矩阵的K邻域，并将各K邻域对应的标签集合中的标签分别进行输出，根据各K邻域输出的标签结果判断涕液特征的文本对应的标签。</p>
                </li>
                <li>
                  <i class="apply-icon15"></i>
                  <h4>基于噩梦的疾病认知模型构建方法及疾病认知系统</h4>
                  <p>收集噩梦的相关描述文本，将描述文本作为训练语料切分为噩梦特征信息分词；对噩梦特征信息分词进行归一化，得到对应的归一化样本及分词集合；基于最大熵模型对噩梦特征信息分词进行训练，得到噩梦特征的预分类模型；建立噩梦语义特征集合所对应的疾病以及疾病知识库；通过预分类模型对输入的待识别噩梦特征信息分类，基于噩梦语义特征与疾病的对应关系、疾病知识库，匹配输出噩梦对应的疾病及解决方案。</p>
                </li>
                <li>
                  <i class="apply-icon16"></i>
                  <h4>出血性疾病的智能预测模型构建方法</h4>
                  <p>建立身体出血外显的信息表征的特征信息与出血性疾病症状特征信息映射关系的数据库；根据获取到的身体出血外显的信息表征与出血性疾病症状特征信息表示的匹配关系，建立身体出血外显的信息表征与出血性疾病对之间特征信息的语义相似度的计算模型。</p>
                </li>
                <li>
                  <i class="apply-icon17"></i>
                  <h4>基于流行性感冒智能认知模型的系统</h4>
                  <p>基于流感症状描述这种非公开的语料，进行文本输入、分词、文本表示的降维压缩，并构建观测向量及可能对应的分类的状态值，通过构建线链条件随机场，求取分类对应的概率，采用特定数据训练该模型，提高模型对特定非公开语料文本数据的识别、分析和归类能力。</p>
                </li>
                <li>
                  <i class="apply-icon18"></i>
                  <h4>基于异常流泪特征认知的建模方法</h4>
                  <p>采集泪液分泌异常的症状及相关文献，获取导致泪液分泌异常的各种症状及所有可能的原因的特征信息；针对泪液分泌异常的各种症状及各症状原因的特征信息进行分词；对分词后的内容进行TF—IWF筛选，删除其中的停用词，并提取关键词；将提取的关键词作为测试数据和类别标签，标签构建样本库；利用原型网络进行小样本学习，将样本库分为训练集和测试集，求取类别标签对应的原型和测试数据属于某一类别标签的概率；对进行了类别标签关联的测试数据和类别标签的关键词，采用自适应增强学习算法进一步进行分类训练和优化。</p>
                </li>
                <li>
                  <i class="apply-icon19"></i>
                  <h4>基于电子病历的肝病认知系统</h4>
                  <p>获取历史病历数据，提取肝病数据信息，对肝病数据信息进行预处理，获取预处理后的肝病数据信息作为待划分数据；通过ICTCLAS分词工具从待划分数据中划分出肝病描述特征信息，并生成对应的肝病描述特征信息数据集；通过IV值分析方法对肝病描述特征信息数据集进行特征筛选，并生成对应特征表格，将该特征表格作为诊断系统模型；获取待诊断肝病描述特征信息，利用诊断系统模型对待诊断肝病描述特征信息进行诊断认知。</p>
                </li>
                <li>
                  <i class="apply-icon20"></i>
                  <h4>基于儿童异常行为的疾病预测系统</h4>
                  <p>通过摄像机实时采集儿童行为视频信息以及对应的时序运动信息，从儿童行为视频信息以及对应的时序运动信息中提取行为特征信息以及时序运动特征信息，根据行为特征信息以及时序运动特征信息建立样本特征模型。获取待识别儿童个体特征信息，建立待识别儿童个体特征集；根据该KNN算法模型通过样本特征模型对待识别儿童个体特征集进行预测，并生成对应预测报告。</p>
                </li>
                <li>
                  <i class="apply-icon21"></i>
                  <h4>基于上消化道出血预测疾病的系统</h4>
                  <p>从电子病例库中提取出以上消化道出血作为临床第一主诉症状的病例样本；提取各病例样本中上消化道出血的症状信息、相关生物学指标数据以及对应的疾病名称，组成病例样本特征向量；采用改进的鸟群算法优化的K均值聚类算法对所述病例样本特征向量聚类；对待诊断病例进行聚类，建立基于上消化道出血的症状信息和生物学指标数据的联合诊断模型。</p>
                </li>
                <li>
                  <i class="apply-icon22"></i>
                  <h4>基于妇女白带的疾病认知模型构建方法及系统</h4>
                  <p>获取妇女白带特征信息、常规检查数据值以及白带异常对应的疾病和疾病特征信息集；基于AdaBoost算法对妇女白带特征信息和常规检查数据值进行计算，根据计算结果建立异常白带自学习模型；基于组合算法和异常白带自学习模型建立诊断模型，以根据所述诊断模型对待诊断妇女白带异常特征信息和数据值进行诊断。</p>
                </li>
                <li>
                  <i class="apply-icon23"></i>
                  <h4>基于尿酸值域范围智能疾病认知系统</h4>
                  <p>采集待诊断尿酸数据，获取尿酸标准指标数值范围根据尿酸标准指标数值范围对待诊断尿酸数据进行处理，获取指标数据；建立多元logistics回归算法，获取待诊断用户身体数据，计算待诊断用户身体数据与指标数据之间的概率值；建立正则表达式，利用正则表达式将指标数据、概率值和待诊断用户身体数据与尿酸标准指标数值范围以及对应的疾病信息进行匹配；根据匹配结果生成对应诊断报告。</p>
                </li>
                <li>
                  <i class="apply-icon24"></i>
                  <h4>基于血脂检查指标智能推测疾病系统</h4>
                  <p>采集血脂数值，并对该血脂数值进行预处理，获取处理后的血脂数值；获取血脂范围参考数据值以及对应的疾病数据，根据该血脂范围参考数据值以及对应的疾病数据建立区间判断模型；建立复关系数，根据该复关系数对处理后的血脂数值进行测算，获取测算后的待判断数据；通过区间判断模型对待判断数据进行判断，获取判断结果。</p>
                </li>
                <li>
                  <i class="apply-icon25"></i>
                  <h4>基于心血管系统感染智能认知系统</h4>
                  <p>获取各种心血管系统感染病例分类的诊断标准的具体指标；提取每一类心血管系统感染病例分类所包含的主要特征信息，建立标准数据库；对所述标准数据库的主要特征信息进行文本挖掘，提取特征向量，得到每个心血管系统感染病例分类对应的特征向量集合；提取待分类病例描述文本的特征向量，分别计算待分类病例描述文本的特征向量与所述特征向量集合中元素之间的相似度；根据所述相似度对待分类文本进行病例匹配和分类。</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <!-- 新首页内容End -->
      <div class="join">
        <p>和我们一起开启大健康领域人体医学生物特征认知计算新时代</p>
        <a @click="logining()">申请加入吾征AI</a>
      </div>
    <!-- </wrap> -->
    <app-footer />
  </div>
</template>

<script>
import { request } from '@/network/request'
import header from '@/components/header'
import footer from '@/components/footer'
import Swiper from 'swiper'
import flickerplate from '@/assets/js/flickerplate.min.js'
import Cookies from 'js-cookie'
import { profile } from '@/api/user'
var i = 0;
export default {
  data () {
    return {
      msg: [],
    }
  },
  components: {
    'app-header': header,
    'app-footer': footer,
  },
  mounted () {
    $('.flicker-example').flicker();
    $(".z-ai-tab span").click(function () {
      $(".z-ai-tab span").eq($(this).index()).addClass("active").siblings().removeClass('active');
      $(".z-ai-list").eq($(".z-ai-tab span").index(this)).addClass("zshow").siblings().removeClass('zshow');
    });

        let _this = this;
    request({
      url: '/intelligentDetection/device/intelligentDetection',
      method: 'get',
      params: {}
    }).then(res => {
      if (res.data.code == 200) {
        _this.msg = res.data.data;

      } else {

      }

    });
  },
   methods: {
    youjian(){
    fetch('http://node.wuzhengai.com/sendmail', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    host:'smtp.263.net',
    pass:'aL8d9hFb6b0kDiEnag4mCcDnag7uDm7r',
    from:'zhaotianhong@infobigdata.com', //发送者邮箱
    to:'wangzhenhua@infobigdata.com', //接受者邮箱,可以设置多个
    subject: '测试邮件发送', // 邮件主题
    text: '再次发送3_6' // 邮件正文
  })
})
.then(response => response.text())
.then(result => console.log(result))
.catch(error => console.log(error));

    },
        tiao(n, i) {
      let _this = this;
      Cookies.set('typein', 1);
      profile().then(response => {
        if (response.data.code == 200) {
          sessionStorage.setItem('topic', n);
          sessionStorage.setItem('topicname', i);
          localStorage.setItem('baogaoid', 'null');
          _this.$router.push('/topic');

        } else {
          _this.$router.push('/login');
        }
      })

    },
      // 判断是否登陆
    logining () {
      let _this = this;
      Cookies.set('typein',1);
      profile().then(response => {
        if (response.data.code == 200) {

      _this.$message({
        showClose: true,
        type: 'success',
        message: '您已加入',
        offset:130
        });
        }else{

          _this.$router.push('login');
        }
      })
    }
     ,
    shaicha() {
        $.extend({
          PostSubmitForm: function (url, args) {
              var body = $(document.body),
                    form = $("<form method='post' style='display:none'></form>"),
                input;
              form.attr({ "action": url });
              $.each(args, function (key, value) {
                  input = $("<input type='hidden'>");
                  input.attr({ "name": key });
                  input.val(value);
                  form.append(input);
              });

              form.appendTo(body);
              form.submit();
              body.removeChild(form[0]);
          }
      });
      let _this = this;
      Cookies.set('typein',1);
      profile().then(response => {
        if (response.data.code == 200) {

        //  $.PostSubmitForm('http://densecare.infobigdata.com/densecare-web-admin/logins', {username:response.data.data.phone })
         $.PostSubmitForm('http://dense.wuzhengai.com/densecare-web-admin/logins', {username:response.data.data.phone })

        }else{
          _this.$router.push('login');
        }
      })





    }}
}
</script>

<style>
@import "./../assets/css/index.css";
@import "./../assets/css/swiper.min.css";
/* 新首页样式 */
@import "./../assets/css/style.css";
@import "./../assets/css/new-style.css";
@import "./../assets/css/page.css";
@import "./../assets/css/banner.css";
/* @import "./../assets/css/h5.css"; */
@import "./../assets/css/NewFile.css";

.zhongjiantu3_25 {
  width: 100%;
  background-color: #fff;
}

.zhongjiantu3_25 .continto {
  width: 1140px;
  margin: 0 auto;
  padding-bottom: 30px;
}

.weiqunabox3_25 .weiquna3_25:nth-child(3n) {
  margin-right: 0;
}

.weiquna3_25 {
  width: 360px;
  height: 302px;
  background: #FFFFFF;
  border-radius: 5px;
  float: left;
  padding: 30px 20px;
  box-sizing: border-box;
  margin-right: 28px;
  margin-top: 60px;
  border: 1px solid #E6E6E6;
}

.weiquna3_25:hover {
  border: 1px solid #fff;
  box-shadow: 0 0 14px 0 rgba(0, 0, 0, .08);
}

.weiquna3_25 .img {
  width: 64px;
  height: 64px;
  float: left;
  margin: 0 128px;
  margin-bottom: 30px;
}

.weiquna3_25 .titlewei {
  width: 100%;
  float: left;
  text-align: center;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
}

.weiquna3_25 .titleweips {
  width: 100%;
  float: left;
  text-align: center;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 20px;
  margin-top: 12px;
  margin-bottom: 20px;
}

.weiquna3_25 .btnuni:hover {
  border: 1px solid #14C86C;
  background: #14C86C;
  color: #FFFFFF;
}

.weiquna3_25 .btnuni {
  width: 200px;
  height: 50px;
  line-height: 50px;
  float: left;
  text-align: center;
  border-radius: 5px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000;
  margin-left: 60px;
  background: #FFFFFF;
  border: 1px solid #E6E6E6;
  cursor: pointer;
}

.zhongjiantu3_25 .titlein {
  width: 100%;
  text-align: center;
  float: left;
  font-size: 40px;
  /* font-family: PingFang SC;
  font-weight:bold;*/
  color: #000000;
  line-height: 42px;
  margin: 100px 0;

}

.zhongjiantu3_25 .titleinps {
  width: 100%;
  float: left;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
}

.pictxt {
  background: url(../assets/images/home_Picturetext.png) no-repeat center bottom;
  height: 590px;
}
.imga {
  margin: 0 auto;
  margin-top: 30px;
  padding: 3% 0;
}
.swiper-button-prev {
  width: 50px;
  height: 50px;
  /* background: ==333 url(../images/btnleft.png) no-repeat 8px 4px; */
  position: absolute;
  left: 0;
  top: 50%;
  opacity: 0.6;
  filter: Alpha(opacity=60);
  margin-top: -25px;
  border-radius: 50% 50%;
}
.swiper-button-next {
  width: 50px;
  height: 50px;
  /* background: #333 url(../images/btnright.png) no-repeat 18px 4px; */
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -25px;
  opacity: 0.6;
  filter: Alpha(opacity=60);
  border-radius: 50% 50%;
}
.btna {
  display: none;
}
.bannera:hover .btna {
  display: block;
}
.be_banner {
  position: relative;
}
.be_botBtn {
  width: 100%;
  text-align: center;
  position: absolute;
  left: 0;
  bottom: 10px;
}
.be_botBtn a {
  display: inline-block;
  width: 100px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  font-size: 20px;
  color: #fff;
  border: 1px solid #fff;
  margin: 0 10px;
}
.index_pro a img {
  border: 1px solid #eee;
}

.join {
  width: 100%;
  height: 200px;
  margin: 0 auto;
  background: url(../assets/img/join-bg.jpg) no-repeat;
  background-size: cover;
  position: relative;
}
.join:before {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background: #17b978;
  opacity: 0.8;
}
.join p {
  position: absolute;
  top: 50px;
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 26px;
  color: #fff;
}
.join a {
  position: absolute;
  left: 50%;
  bottom: 50px;
  width: 150px;
  margin-left: -75px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #fff;
  font-size: 16px;
  color: #333;
  font-weight: 700;
}
.join a:hover {
  color: #14c86c;
}

/* * 多内容轮播 * */
.cont4.zapply {
  width: 100%;
  background: url(/static/img/zapply_bg.81a79cd.jpg) repeat-y center;
  padding-bottom: 100px;
}
.container {
  margin: 0 auto;
  width: 1200px;
}
.zapply .textC {
  font-size: 40px;
  color: #fff;
  padding: 100px 0 50px 0;
}
/* 轮播样式 */
.flickerplate {
  width: 1200px;
  height: 400px;
  margin-top: -20px;
  position: relative;
  background: none;
}
.flicker-box {
  width: 1200px;
  height: 400px;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
}
.flickerplate ul.flicks {
  width: 10000%;
  height: 100%;
}
.flickerplate ul.flicks > li {
  float: left;
  width: 1%;
  height: 100%;
  background-position: center;
  background-size: cover;
  display: table;
  position: relative;
}

.flickerplate .arrow-navigation {
  position: absolute;
  height: 80%;
  width: 10%;
  top: 0;
  z-index: 100;
  overflow: hidden;
}
.flickerplate .arrow-navigation .arrow {
  display: block;
  height: 100%;
  width: 90%;
  -webkit-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  -ms-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}
.flickerplate .arrow-navigation:hover,
.flickerplate .arrow-navigation .arrow:hover {
  cursor: pointer;
}
.flickerplate .arrow-navigation.left {
  left: 0%;
}
.flickerplate .arrow-navigation.left .arrow {
  opacity: 0.2;
  margin: 0px 0px 0px 50%;
  background-image: url("../assets/img/flickerplate/arrow-left-light.png");
  background-repeat: no-repeat;
  background-position: left;
}
.flickerplate .arrow-navigation.right {
  right: 0%;
}
.flickerplate .arrow-navigation.right .arrow {
  opacity: 0.2;
  margin: 0px 0px 0px -50%;
  background-image: url("../assets/img/flickerplate/arrow-right-light.png");
  background-repeat: no-repeat;
  background-position: right;
}
.flickerplate .arrow-navigation.left.hover .arrow {
  opacity: 1;
  margin: 0px 0px 0px 20%;
}
.flickerplate .arrow-navigation.right.hover .arrow {
  opacity: 1;
  margin: 0px 0px 0px -20%;
}

/* DOT STAR */
.cont4 .flickerplate .dot-navigation {
  position: absolute;
  bottom: 0px;
  width: 100%;
  text-align: center;
  z-index: 100;
}
.flickerplate .dot-navigation ul {
  text-align: center;
  list-style: none;
  padding: 0px 15px;
}
.flickerplate .dot-navigation ul li {
  display: inline-block;
  float: none;
}
.flickerplate .dot-navigation .dot {
  width: 14px;
  height: 14px;
  margin: 0px 6px;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  -o-border-radius: 50%;
  -ms-border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  -webkit-transition: background-color 0.2s ease-out;
  -moz-transition: background-color 0.2s ease-out;
  -o-transition: background-color 0.2s ease-out;
  -ms-transition: background-color 0.2s ease-out;
  transition: background-color 0.2s ease-out;
}
.flickerplate .dot-navigation .dot:hover {
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.6);
}
.flickerplate .dot-navigation .dot.active {
  background-color: #14c86c;
}
.flickerplate .dot-navigation.left,
.flickerplate .dot-navigation.left ul {
  text-align: left;
}
.flickerplate .dot-navigation.right,
.flickerplate .dot-navigation.right ul {
  text-align: right;
}
.flickerplate.flicker-theme-dark .arrow-navigation.left .arrow {
  background-image: url("../assets/img/flickerplate/arrow-left-dark.png");
}
.flickerplate.flicker-theme-dark .arrow-navigation.right .arrow {
  background-image: url("../assets/img/flickerplate/arrow-right-dark.png");
}
.flickerplate.flicker-theme-dark .dot-navigation .dot {
  background-color: rgba(0, 0, 0, 0.12);
}
.flickerplate.flicker-theme-dark .dot-navigation .dot:hover {
  background-color: rgba(0, 0, 0, 0.6);
}
.flickerplate.flicker-theme-dark .dot-navigation .dot.active {
  background-color: #000;
}
/* DOT END */

.flickerplate.animate-transform-slide ul.flicks {
  -webkit-perspective: 1000;
  -webkit-backface-visibility: hidden;
  transform: translate3d(0%, 0px, 0px);
  -webkit-transform: translate3d(0%, 0px, 0px);
  -webkit-transition: -webkit-transform 0.6s;
  -o-transition: -o-transform 0.6s;
  -moz-transition: -moz-transform 0.6s;
  transition: transform 0.6s;
}
.flickerplate.animate-transition-slide ul.flicks {
  position: relative;
  left: 0%;
  -webkit-transition: left 0.4s ease-out;
  -moz-transition: left 0.4s ease-out;
  -o-transition: left 0.4s ease-out;
  -ms-transition: left 0.4s ease-out;
  transition: left 0.4s ease-out;
}
.flickerplate.animate-jquery-slide ul.flicks {
  position: relative;
  left: 0%;
}
.flickerplate.animate-scroller-slide {
  padding-bottom: 0px;
  overflow: auto;
}
.flickerplate.animate-scroller-slide ul.flicks {
  position: auto;
}

.flicker-example ul li i {
  float: left;
  width: 64px;
  height: 64px;
  background: url(../assets/img/applyIcon.png) no-repeat center -65px;
  position: absolute;
  left: 50%;
  margin-left: -32px;
  top: 0;
}
.flicker-example ul li .apply-icon1 {
  background-position: 0 0;
}
.flicker-example ul li .apply-icon2 {
  background-position: -64px 0;
}
.flicker-example ul li .apply-icon3 {
  background-position: -128px 0;
}
.flicker-example ul li .apply-icon4 {
  background-position: -192px 0;
}
.flicker-example ul li .apply-icon5 {
  background-position: -256px 0;
}
.flicker-example ul li .apply-icon6 {
  background-position: -320px 0;
}
.flicker-example ul li .apply-icon7 {
  background-position: -384px 0;
}
.flicker-example ul li .apply-icon8 {
  background-position: -448px 0;
}
.flicker-example ul li .apply-icon9 {
  background-position: -512px 0;
}
.flicker-example ul li .apply-icon10 {
  background-position: -576px 0;
}
.flicker-example ul li .apply-icon11 {
  background-position: -640px 0;
}
.flicker-example ul li .apply-icon12 {
  background-position: -704px 0;
}
.flicker-example ul li .apply-icon13 {
  background-position: -768px 0;
}
.flicker-example ul li .apply-icon14 {
  background-position: -832px 0;
}
.flicker-example ul li .apply-icon15 {
  background-position: -896px 0;
}
.flicker-example ul li .apply-icon16 {
  background-position: -960px 0;
}
.flicker-example ul li .apply-icon17 {
  background-position: -1024px 0;
}
.flicker-example ul li .apply-icon18 {
  background-position: -1088px 0;
}
.flicker-example ul li .apply-icon19 {
  background-position: -1152px 0;
}
.flicker-example ul li .apply-icon20 {
  background-position: -1216px 0;
}
.flicker-example ul li .apply-icon21 {
  background-position: -1280px 0;
}
.flicker-example ul li .apply-icon22 {
  background-position: -1344px 0;
}
.flicker-example ul li .apply-icon23 {
  background-position: -1408px 0;
}
.flicker-example ul li .apply-icon24 {
  background-position: -1472px 0;
}
.flicker-example ul li .apply-icon25 {
  background-position: -1536px 0;
}
.flicker-example ul li h4 {
  height: 60px;
  line-height: 60px;
  font-size: 26px;
  color: #fff;
  text-align: center;
  padding-top: 100px;
}
.flicker-example ul li p {
  padding: 0 200px;
  line-height: 30px;
  text-align: left;
  text-indent: 2em;
  margin-top: 70px;
  color: #fff;
  font-size: 16px;
}

.meitd {
  padding: 60px 0;
}
.meitdbox {
  width: 1200px;
  margin: 0 auto;
}
.index_cont_img {
  float: left;
  width: 600px !important;
  padding: 0 15px !important;
  margin-top: -4% !important;
}
.index_cont_img img {
  width: 100%;
}
.index_cont_txtlist {
  float: left;
  width: 570px !important;
  padding: 0 15px;
  margin-left: 0 !important;
}

/* CSS动效 */
@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}

@keyframes upDown {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  25% {
    -webkit-transform: translateY(-40px);
    transform: translateY(-40px);
  }
  50% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  75% {
    -webkit-transform: translateY(40px);
    transform: translateY(40px);
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}
@-webkit-keyframes upDown {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  25% {
    -webkit-transform: translateY(-40px);
    transform: translateY(-40px);
  }
  50% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  75% {
    -webkit-transform: translateY(40px);
    transform: translateY(40px);
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}

.dx_w {
  float: left;
  width: 600px;
  height: 396px;
  position: relative;
  background: url(../assets/img/dx_bg.png) no-repeat;
}
.dx_ws {
  position: absolute;
  left: 169px;
  top: 52px;
  width: 290px;
  height: 290px;
  background: url(../assets/img/dx_spin.png) no-repeat;
  -webkit-animation: fa-spin 6.6s infinite linear;
  animation: fa-spin 6.6s infinite linear;
}
.dx_wimg {
  position: absolute;
  left: 214px;
  top: 88px;
  z-index: 9;
}
.dx_wd {
  position: absolute;
  right: 94px;
  top: 63px;
  width: 30px;
  height: 32px;
  background: url(../assets/img/dx_dot.png) no-repeat;
  -webkit-animation: fa-spin 6.6s infinite linear;
  animation: fa-spin 6.6s infinite linear;
}
.dx_wl {
  position: absolute;
  left: 26px;
  top: 180px;
  width: 120px;
  height: 100px;
  animation: upDown 4s linear infinite;
  -webkit-animation: upDown 4s linear infinite;
}
.zhongjiantu6_3 {
  width: 100%;
  height: 400px;
  background: #fff;
  /* background: url(../assets/images/zhongjiantu6_3.png) no-repeat center
    bottom; */
}

.zhongjiantu6_3 .continto {
  width: 1200px;
  margin: 0 auto;
}

.zhongjiantu6_3 .leftcont {
  width: 720px;
  float: left;
  position: relative;
  z-index: 2;
}

.zhongjiantu6_3 .imgin {
  width: 600px;
  height: 400px;
  float: left;
  margin-left: -120px;
  position: relative;
  z-index: 1;
}

.zhongjiantu6_3 .title {
  text-align: left;
  color: #000000;
  font-size: 26px;
  padding: 30px 0;
  line-height: 50px;
}
.btntitle6_3 {
  display: inline-block;
  width: 200px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  background-color:#14C86C;
  font-size: 14px;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
}
.btntitle6_3:hover{
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue